import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-rating-bar',
  templateUrl: './rating-bar.component.html',
  styleUrls: ['./rating-bar.component.scss'],
})
export class RatingBarComponent implements OnInit {
  @Input() ratingValue: number;
  readonly maxGrade = 5;
  ratingValueInPercents = '0';

  constructor() { }

  ngOnInit() {
    this.ratingValueInPercents = ((this.ratingValue * 100) / this.maxGrade).toFixed(0);
  }

}
